// CP-268 follow-up: the Detail cabin tile "Current" comes from the prices
// API's cabin_current_prices, which the backend reads at the same
// collection as the headline "From" (after the copied-stamp and spike
// rules). A cabin with no fare at that collection has no Current: its older
// rows (e.g. a HAL offer-code low) stay on the chart as history only. There
// is no fallback to the newest chart point, so a stale fare can never be
// labelled Current. Returns a positive number, or null.
export function cabinCurrentFare(cruiseInfo, cabinType) {
  const map = cruiseInfo && cruiseInfo.cabin_current_prices;
  if (!map || typeof map !== 'object') return null;
  if (!Object.prototype.hasOwnProperty.call(map, cabinType)) return null;
  const raw = map[cabinType];
  if (raw == null || typeof raw === 'boolean' || raw === '') return null;
  const value = Number(raw);
  return Number.isFinite(value) && value > 0 ? value : null;
}
